import * as e from "react";
import t from "../lib/IconBase.es.js";
import i from "../defs/SpeakerHigh.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: i }));
o.displayName = "SpeakerHighIcon";
const c = o;
export {
  c as SpeakerHigh,
  o as SpeakerHighIcon
};
